/**
 * CRUD client for the small admin reference-data endpoints (warranty fees,
 * RMA fees, warranty statuses) — a plain paginated DRF list plus create /
 * patch / delete. Requests reject on HTTP error (axios default) so callers can
 * surface field-level validation messages through the shared error parser.
 *
 * Contains:
 * - createReferenceCrudApi — build a { list, create, update, remove } client
 *   for one endpoint base path (e.g. '/warrantyfees/')
 */
import apiClient from '@sophocles/http-common';

export default function createReferenceCrudApi(basePath) {
  return {
    list: params => apiClient.get(basePath, { params }).then(response => response.data),
    create: body => apiClient.post(basePath, body).then(response => response.data),
    update: (id, body) => apiClient.patch(`${basePath}${id}/`, body).then(response => response.data),
    remove: id => apiClient.delete(`${basePath}${id}/`).then(response => response.data),
  };
}
